(function () {
  const el = document.getElementById('cart-tiers');
  if (!el) return;

  const tiers = JSON.parse(el.dataset.tiers);
  const last = tiers[tiers.length - 1];

  function render(qty) {
    const current = [...tiers].reverse().find(t => qty >= t.qty);
    const next = tiers.find(t => qty < t.qty);
    const progress = Math.min(100, Math.round((qty / last.qty) * 100));

    let msg;
    if (!next) {
      msg = `🎉 You unlocked <strong>${current.off}% OFF</strong>!`;
    } else if (qty === 0) {
      msg = `Add 1 item to get <strong>${next.off}% OFF</strong>`;
    } else {
      const need = next.qty - qty;
      msg = `Add ${need} more to unlock <strong>${next.off}% OFF</strong>`;
    }

    el.innerHTML = `
      <div class="cart-tiers">
        <p class="cart-tiers__title">BUY MORE, SAVE MORE</p>
        <p class="cart-tiers__msg">${msg}</p>
        <div class="cart-tiers__bar"><span style="width:${progress}%"></span></div>
        <ul class="cart-tiers__list">
          ${tiers.map((t, i) => `
            <li class="${qty >= t.qty ? 'is-active' : ''}">
              Buy ${t.qty}${i === tiers.length - 1 ? '+' : ''} → ${t.off}% OFF
            </li>`).join('')}
        </ul>
      </div>`;
  }

  async function refresh() {
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
      render(cart.item_count);
    } catch (e) { console.error('cart-tiers', e); }
  }

  // Re-run after any cart AJAX call (add, change, update, clear), theme-agnostic
  const origFetch = window.fetch;
  window.fetch = function () {
    const url = String(arguments[0] && arguments[0].url || arguments[0]);
    const p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(() => setTimeout(refresh, 150));
    return p;
  };

  // Fallback: refresh when a classic form-based quantity change reloads or the drawer opens
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('DOMContentLoaded', refresh);
  refresh();
})();